var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"blockrain-game"}}),(_vm.gameId)?_c('b-button',{staticClass:"m-3",attrs:{"variant":"secondary"},on:{"click":_vm.togglePause}},[_vm._v(" "+_vm._s(_vm.isPaused ? 'Reprendre' : 'Pause')+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }